import { defaultCity } from "@constants/cities";
import Cookies from "js-cookie";

type CityCookie = {
  id: number;
  name: string;
  slug: string;
};

const COOKIE_NAME = "selected_city";

const DEFAULT_CITY: CityCookie = {
  id: defaultCity.id,
  name: defaultCity.name,
  slug: defaultCity.city_slug,
}

export const getSelectedCityClient = (): CityCookie => {
  const raw = Cookies.get(COOKIE_NAME);

  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      if (parsed?.id && parsed?.name && parsed?.slug) {
        return parsed as CityCookie;
      }
    } catch (err) {
      console.warn("selected_city cookie is corrupted. Resetting to default.");
    }
  }

  // If not found or malformed, set and return default city
  setSelectedCityClient(DEFAULT_CITY);
  return DEFAULT_CITY;
};

export const setSelectedCityClient = (city: CityCookie): void => {
  Cookies.set(COOKIE_NAME, JSON.stringify(city), {
    expires: 365, // days
    sameSite: "strict",
  });
};
